
export const strongVoteDelay = 1000;
